import type { LinkSize, LinkVariant } from '../types/components';
import colors from '../utils/colors';

// @deprecated in favor of union types
export const TYPES: Record<string, LinkVariant> = {
  NORMAL: 'normal',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  SUCCESS: 'success',
  ERROR: 'error',
};

// @deprecated in favor of union types
export const SIZES: Record<string, LinkSize> = {
  NORMAL: 'md',
  SMALL: 'sm',
  XS: 'xs',
  XXS: 'xxs',
};

export const LINK_COLOR: Record<LinkVariant, string> = {
  normal: colors.ink100,
  primary: colors.primary100,
  secondary: colors.info100,
  tertiary: colors.ink50,
  success: colors.success100,
  error: colors.error100,
  dark: colors.ink100,
};

type ConfigProps = {
  fontSize: number;
  lineHeight: number;
};

// This config can be used by both web & mobile
// lineHeight will be converted within StandardText for mobile
export const SIZE_CONFIG: Record<LinkSize, ConfigProps> = {
  md: {
    fontSize: 15,
    lineHeight: 1.333,
  },
  sm: {
    fontSize: 13,
    lineHeight: 1,
  },
  xs: {
    fontSize: 11,
    lineHeight: 1,
  },
  xxs: {
    fontSize: 9,
    lineHeight: 1,
  },
};
